import React, { useCallback, useState } from "react";
import GoogleMapReact from 'google-map-react';



const MessageLocation = ({ currentMessage, position, renderTicks }: any) => {
    const { latitude, longitude } = currentMessage.location

    const openGoogleMap = () => {
        const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}&zoom=16`;
        window.open(url, "_blank");
    };

    return (
        <>
            <div className={position === "left" ? "talk_group flip" : "talk_group w-clearfix"}>
                <div className={position === "left" ? "buble flip" : "buble"}>
                    <div className="buble_pict">
                        <img style={{ cursor: 'pointer', direction: "ltr" }} onClick={openGoogleMap} src="/assets/images/google-maps.jpg" alt="" />
                    </div>
                </div>
                {renderTicks()}
            </div>
        </>
    )
}


export default MessageLocation;